"use strict";
exports.__esModule = true;
exports.formatOutput = exports.formatInput = void 0;
var currencies_1 = require("../../currencies");
var env_1 = require("../../env");
var logic_1 = require("./logic");
var sortUTXO = function (a, b) { return b.value.minus(a.value).toNumber(); };
function injectGetAddressParams(account) {
    var perCoin = logic_1.perCoinLogic[account.currency.id];
    if (perCoin && perCoin.injectGetAddressParams) {
        return perCoin.injectGetAddressParams(account);
    }
}
function formatInput(account, input) {
    return "".concat((input.value
        ? (0, currencies_1.formatCurrencyUnit)(account.unit, input.value, {
            showCode: false
        })
        : "").padEnd(12), " ").concat(input.address || "", " ").concat(input.previousTxHash || "", "@").concat(input.previousOutputIndex);
}
exports.formatInput = formatInput;
function formatOutput(account, o) {
    return [
        (0, currencies_1.formatCurrencyUnit)(account.unit, o.value, {
            showCode: false
        }).padEnd(12),
        o.address,
        o.isChange ? "(change)" : "",
        o.rbf ? "rbf" : "",
        o.hash,
        "@".concat(o.outputIndex, " (").concat(o.blockHeight ? account.blockHeight - o.blockHeight : 0, ")"),
    ]
        .filter(Boolean)
        .join(" ");
}
exports.formatOutput = formatOutput;
function formatAccountSpecifics(account) {
    if (!account.bitcoinResources)
        return "";
    var utxos = account.bitcoinResources.utxos;
    var str = "\n".concat(utxos.length, " UTXOs");
    var n = (0, env_1.getEnv)("DEBUG_UTXO_DISPLAY");
    var displayAll = utxos.length <= n;
    str += utxos
        .slice(0)
        .sort(sortUTXO)
        .slice(0, displayAll ? utxos.length : n)
        .map(function (utxo) { return "\n".concat(formatOutput(account, utxo)); })
        .join("");
    if (!displayAll) {
        str += "\n...";
    }
    return str;
}
exports["default"] = {
    injectGetAddressParams: injectGetAddressParams,
    formatAccountSpecifics: formatAccountSpecifics
};
//# sourceMappingURL=account.js.map